import { render, staticRenderFns } from "./icon-infinity.vue?vue&type=template&id=b8db9104&"
import script from "./icon-infinity.vue?vue&type=script&lang=ts&"
export * from "./icon-infinity.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports